import { CALL_METHODS } from '../../../../types';

export const getDefaultPayloadForMethod = (method: string) => {
  switch (method) {
    case CALL_METHODS.NAVIGATE:
      return { url: '/campaigns/new' };

    case CALL_METHODS.SET_FORM_FIELDS:
      return {
        form: 'app/CampaignPageForm',
        fields: {},
        streamingDelay: 50,
      };

    case CALL_METHODS.SET_CONTEXT:
      return {};

    case CALL_METHODS.SEARCH_NONPROFITS:
      return {
        outputPath: 'searchResults',
        searchTerm: '',
        limit: 10,
        acceptsDonations: true,
        waitForCompletion: true,
      };

    case CALL_METHODS.GENERATE:
      return {
        generationId: 'campaign-content-generator',
      };

    case CALL_METHODS.BATCH_GENERATE:
      return {
        form: 'app/CampaignPageForm',
        batches: [],
      };

    case CALL_METHODS.LOAD_NONPROFITS:
      return {
        inputPath: 'selectedNonprofitIds',
        outputPath: 'loadedNonprofits',
        waitForCompletion: true,
      };

    case CALL_METHODS.LOAD_CAUSES:
      return {
        sdgsOutputPath: 'sdgs',
        categoriesOutputPath: 'categories',
        waitForCompletion: true,
      };

    case CALL_METHODS.LOAD_PICTURES:
      return {
        outputPath: 'pictures',
        waitForCompletion: true,
      };

    case CALL_METHODS.LOAD_USER:
      return {
        outputPath: 'user',
        waitForCompletion: true,
      };

    case CALL_METHODS.SET_DEFAULT_PICTURE:
      return {
        form: 'app/CampaignPageForm',
        categories: [],
      };

    case CALL_METHODS.DEBUG:
      return {
        message: 'Impact AI Context Debug',
        includeTimestamp: true,
      };

    case CALL_METHODS.DELAY:
      return { delay: 1000 };

    case CALL_METHODS.PARSE_DATA:
      return {
        script:
          'function processData(context, ui) {\n  // Your data parsing logic here\n  return context;\n}',
      };

    case CALL_METHODS.REDUX:
      return {
        get: [],
        set: [],
      };

    default:
      return {};
  }
};
